module.exports = __webpack_public_path__ + "media/images/pets2-235a92c720c748eaac527e1e049ae165.jpg";